import * as React from 'react';
import { PaginatedSelectInputVariants } from './paginated-select.variants';
import { usePaginatedSelectContext } from './usePaginatedSelectContext';
import { cn } from '@/shared/lib/cn';

interface PaginatedSelectInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
}

function PaginatedSelectInput({
  className,
  placeholder = 'Buscar...',
  ...props
}: PaginatedSelectInputProps) {
  const ctx = usePaginatedSelectContext();
  const { search, setSearch, isLoading, disabled } = ctx as {
    search: string;
    setSearch: (search: string) => void;
    isLoading: boolean;
    disabled: boolean;
  };
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (inputRef.current && !isLoading) {
      inputRef.current.focus();
    }
  }, [isLoading]);

  return (
    <div className="relative">
      <svg
        className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
      <input
        ref={inputRef}
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={cn(
          PaginatedSelectInputVariants({
            class: 'pl-8 pr-4',
          }),
          'border border-outline rounded-[0.5rem]',
          className,
        )}
        {...props}
      />
    </div>
  );
}

export { PaginatedSelectInput };
